import { defineComponent, computed } from "vue";
import { u as useModelMigration } from "./useModelMigration-EhAWvqDD.mjs";
import { r as register, v as t44, a as t } from "./_l10n-DmTbp_o_.mjs";
import { c as createElementId } from "./createElementId-DhjFt1I9.mjs";
import { N as NcSelect } from "./NcSelect-B-X6xD0o.mjs";
import { n as normalizeComponent } from "./_plugin-vue2_normalizer-DU4iP6Vu.mjs";
register(t44);
function formatTimezoneId(timezoneId) {
  return timezoneId.slice(timezoneId.indexOf("/") + 1).replaceAll("/", " - ").replaceAll("_", " ");
}
function getTimezones() {
  return Intl.supportedValuesOf("timeZone").filter((tz) => !tz.startsWith("Etc/")).map((timezoneId) => ({
    timezoneId,
    label: formatTimezoneId(timezoneId)
  })).sort((a, b) => a.timezoneId.localeCompare(b.timezoneId));
}
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcTimezonePicker",
  props: {
    additionalTimezones: { default: () => [] },
    value: { default: void 0 },
    modelValue: { default: "floating" },
    uid: { default: createElementId() }
  },
  emits: ["input", "update:modelValue", "update:model-value"],
  setup(__props) {
    const props = __props;
    const model = useModelMigration("value", "input");
    const formattedAdditionalTimezones = computed(() => {
      return props.additionalTimezones.map(({ timezoneId, label }) => ({
        timezoneId,
        label
      }));
    });
    const options = computed(() => {
      const timezones = getTimezones();
      timezones.unshift(...formattedAdditionalTimezones.value);
      return timezones;
    });
    function filterBy(option, label, search) {
      const terms = search.trim().split(/\s+/);
      const values = Object.values(option);
      return terms.every((term) => {
        return values.some((value) => value.toLowerCase().includes(term.toLowerCase()));
      });
    }
    return { __sfc: true, props, model, formattedAdditionalTimezones, options, filterBy, t, NcSelect };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.NcSelect, { attrs: { "aria-label-combobox": _setup.t("Search for time zone"), "clearable": false, "filter-by": _setup.filterBy, "multiple": false, "options": _setup.options, "placeholder": _setup.t("Type to search time zone"), "uid": _vm.uid, "reduce": (option) => option.timezoneId, "label": "label" }, model: { value: _setup.model, callback: function($$v) {
    _setup.model = $$v;
  }, expression: "model" } });
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const NcTimezonePicker = __component__.exports;
export {
  NcTimezonePicker as N
};
//# sourceMappingURL=NcTimezonePicker-BtQnkDvx.mjs.map
